<template>
  <span class="fa-stack">
    <i :class="['fas fa-circle fa-stack-2x', accountTypes[type].iconBackGroundColor]"></i>
    <i :class="['fas', accountTypes[type].icon, 'fa-stack-1x fa-inverse text-white']"></i>
  </span>
</template>

<script>

import AccountTypes from "@/mixins/account/AccountTypes"

export default {
  props: {
    type: {},
  },

  mixins : [ AccountTypes ],
  
};
</script>

<style>
</style>